import React from 'react';

export default function Hero() {
  return (
    <section className="hero-container" id="pro-nas">
      <div className="hero-content" data-aos="fade-right">
        <h1 className="hero-title">VESNYANKY - це спільнота для дівчат підприємиць та експерток</h1>
        <p>Шукаєш нові знання, натхнення, нові знайомства, ідеї для колаборацій, підтримку та класне оточення?</p>
        <p>Тоді тобі точно до нас. Обирай зручний для себе тариф і насолоджуйся усіма перевагами спільноти.</p>
        <a href="#products" className="cta-button">Придбати підписку</a>
      </div>
      <div className="hero-image" data-aos="fade-left">
        <img src="/images/team.webp" alt="Команда VESNYANKY" width="1383" height="922" />
      </div>
    </section>
  );
}